import contentHelper from "utilities/contentHelper";
import { CONSTANTS } from "utilities/constants";
import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";


/**
 * To validate if there is any itinerary selected in step 1
 *
 * @param {Object} customQuote - custom quote object.
 * @param {Object} errors - the error object.
 * @param {Object} localize - an object of localizer.
 */
function validateItinerarySelection(customQuote, errors, localize) {

    let { quoteOptions } = customQuote?.data || [];

    for (const quoteOption of quoteOptions) {
        for (const product of quoteOption.products ?? []) {
            for (const itinerary of product.itineraries ?? []) {
                if(itinerary.included) {
                    errors.itinerarySelection = "";
                    return;
                }
            }
        }
    }

    errors.itinerarySelection = localize("qma-custom-quote-itinerary-not-selected");

}

/**
 * To validate if there is any invalid data entered for markup in step 2
 *
 * @param {Object} customQuote - custom quote object.
 * @param {Object} errors - the error object.
 * @param {Object} localize - an object of localizer.
 */
function validateIndividualItineraryMarkupSelection(customQuote, errors, localize) {

    if(customQuote?.data?.markupCoverage) {

        if(customQuote.data.markupCoverage === CONSTANTS.MARKUP_COVERAGE_ALL) {
            if(validateMarkup(customQuote.data?.markup) === false) {
                errors.individualItineraryMarkupSelection = localize("qma-custom-quote-markup-not-completed");
                return;
            }
        }
        else {
            let { quoteOptions } = customQuote?.data || [];

            for (const quoteOption of quoteOptions) {
                for (const product of quoteOption.products ?? []) {
                    for (const itinerary of product.itineraries ?? []) {
                        if(itinerary.included && itinerary.markup && (validateMarkup(itinerary.markup) === false)) {
                            errors.individualItineraryMarkupSelection = localize("qma-custom-quote-markup-not-completed");
                            return;
                        }
                    }
                }
            }
        }
        
        errors.individualItineraryMarkupSelection = "";
    }
}

function validateMarkup(markup) {

    let isValid = true;

    if(markup) {
        const limit = markup.type === "amount" ? CONFIGURATION.CUSTOM_QUOTE_MARKUP_AMOUNT_LIMIT : CONFIGURATION.CUSTOM_QUOTE_MARKUP_PERCENT_LIMIT;
        if(markup.adult && (!commonUtilities.isLeadingCorrectZero(markup.adult ?? "") || commonUtilities.toFloat(markup.adult) > limit)) {
            isValid = false;
        }
            
        if(markup.child && (!commonUtilities.isLeadingCorrectZero(markup.child ?? "") || commonUtilities.toFloat(markup.child) > limit)) {
            isValid = false;
        }
    }
    return isValid;
}

/**
 * To validate if there is any invalid data entered for concession in step 3
 *
 * @param {Object} customQuote - custom quote object.
 * @param {Object} errors - the error object.
 * @param {Object} localize - an object of localizer.
 */
function validateSelectedConcessions(customQuote, errors, localize) {

    let { quoteOptions } = customQuote?.data || [];
    for (const quoteOption of quoteOptions) {
        for (const product of quoteOption.products ?? []) {
            for (const itinerary of product.itineraries ?? []) {
                if ( itinerary?.included && !itinerary.hideRoomConcession ) {
                    for (const customConcession of itinerary?.itineraryDetail?.roomType?.customConcessions ?? []) {
                        if(customConcession.included) {
                            const _isValid = contentHelper.validatePlaceHolders(customConcession.placeHolderObjects);
                            if(!_isValid) {
                                errors.selectedConcessions = localize("qma-custom-quote-concession-not-completed");
                                return;
                            }
                        }
                    }
                }
            }
        }

    }
    errors.selectedConcessions = "";
}

/**
 * To validate if there is any invalid data entered for promotion in step 4
 *
 * @param {Object} customQuote - custom quote object.
 * @param {Object} errors - the error object.
 * @param {Object} localize - an object of localizer.
 */
function validateSelectedPromotions(customQuote, errors, localize) {

    let { promotions } = customQuote?.data || [];
    for (const promotion of promotions) {
        const _isValid = contentHelper.validatePlaceHolders(promotion.placeHolderObjects);
        if(!_isValid) {
            errors.selectedPromotions = localize("qma-custom-quote-promotion-not-completed");
            return;
        }
    }

    errors.selectedPromotions = "";
}

const validateCustomQuote = {
    validateItinerarySelection,
    validateIndividualItineraryMarkupSelection,
    validateSelectedConcessions,
    validateSelectedPromotions
};

export default validateCustomQuote;
